<template>
	<transition name="new_playlist">
		<div class="new_playlist">
			<button @click="backPage">back</button>
			<p v-if="getEditingPlaylist">
				Редактирование полей плейлиста: "{{ getPlaylists[getCountPlaylists].display_name }}"
			</p>
			<p v-else>Добавить новый плейлист</p>
			<div class="container">
				<div class="wrap_options">
					<label for="name">Имя на сервере</label>
					<input type="text"
					       autocomplete="off"
					       :value="value.name"
					       id="name"
					       @focus="error = false; coincidence = false; badRequest = false"
					       onkeyup="this.value = this.value.replace(/[^-0-9_a-zA-Z]+$/, '')"/>
				</div>
				<div class="wrap_options">
					<label for="display_name">Отображаемое название</label>
					<input type="text"
					       :value="value.display_name"
					       @focus="error = false; coincidence = false; badRequest = false"
					       id="display_name"/>
				</div>
				<div class="wrap_options" v-show="getReqUserRole === 'Администратор уровня Бог'">
					<label for="domain">Тип клиента</label>
					<select name="domain" id="domain" v-model="type">
						<option value="eltex">eltex</option>
						<option value="app">app</option>
					</select>
				</div>
			</div>
			<button @click="updatePlaylist" v-if="getEditingPlaylist">save changes</button>
			<button @click="createPlaylist" v-else>save new playlist</button>
			<button @click="deletePlaylist" v-if="getEditingPlaylist">delete playlist</button>
			<transition-group tag="div" name="error" class="error">
				<p id="error"
				   :key="1"
				   v-if="error">все поля должны быть заполнены!!!</p>
				<p id="coincidence"
				   :key="2"
				   v-if="coincidence">совпадают имена существующих плейлистов</p>
				<p id="bad_request"
				   :key="3"
				   v-if="badRequest">ошибка: {{ code }} Обратитель к разработчикам... или нет...</p>
			</transition-group>
		</div>
	</transition>
</template>
<script>
	import { performRequest }           from "../script/ws/wsclient";
	import { mapGetters, mapMutations } from "vuex";

	export default {
		name:     "AddNewPlaylist",
		data() {
			return {
				error:       false,
				coincidence: false,
				value:       [],
				old_name:    "",
				badRequest:  false,
				code:        0,
				type:        "eltex"
			};
		},
		mounted() {
			if (!this.getEditingPlaylist) {
				this.value = {
					display_name: "",
					name:         ""
				};
			} else {
				this.old_name = this.getPlaylists[this.getCountPlaylists].name;
				this.value    = this.getPlaylists[this.getCountPlaylists];
				this.type     = this.getPlaylists[this.getCountPlaylists].type;
			}
		},
		methods:  {
			...mapMutations([
				"addNewPlaylist",
				"setPlaylists"
			]),
			backPage() {
				this.$router.push("/playlist");
			},
			updatePlaylist() {
				let name         = document.querySelector("#name").value.trim();
				let display_name = document.querySelector("#display_name").value.trim();
				if (name !== "" && display_name !== "") {
					for (let item of this.getPlaylists) {
						if (item !== this.getPlaylists[this.getCountPlaylists]) {
							if (item.name === name || item.display_name === display_name) {
								return this.coincidence = true;
							} else {
								performRequest(
									{
										section: "tvcontent.playlist",
										name:    "updatePlaylist",
									},
									{
										old_name:     this.old_name,
										name:         document.querySelector("#name")
											              .value.trim(),
										display_name: document.querySelector("#display_name")
											              .value.trim(),
										type:         this.type,
										operator:     this.getViewUser
									},
									a => {
										if (a.code === 200) {
											performRequest(
												{
													section: "tvcontent.playlist",
													name:    "getPlaylistList",
												},
												{
													operator: this.getViewUser
												},
												b => {
													if (b.code === 200) {
														this.setPlaylists(b.data);
														this.$router.push("/playlist");
													}
												}
											);
										} else {
											this.badRequest = true;
											this.code       = a.code;
										}
									}
								);
							}
						}
					}
				} else {
					this.error = true;
				}
			},
			deletePlaylist() {
				performRequest(
					{
						section: "tvcontent.playlist",
						name:    "deletePlaylist"
					},
					{
						name:     this.old_name,
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							performRequest(
								{
									section: "tvcontent.playlist",
									name:    "getPlaylistList"
								},
								{
									operator: this.getViewUser
								},
								b => {
									if (b.code === 200) {
										this.setPlaylists(b.data);
										this.$router.push("/playlist");
									} else {
										console.log("не получил данные");
									}
								}
							);
						} else {
							this.badRequest = true;
							this.code       = a.code;
						}
					}
				);
			},
			createPlaylist() {
				if (
					document.querySelector("#name").value !== "" &&
					document.querySelector("#display_name").value !== ""
				) {
					performRequest(
						{
							section: "tvcontent.playlist",
							name:    "createPlaylist"
						},
						{
							name:         document.querySelector("#name")
								              .value.trim(),
							display_name: document.querySelector("#display_name")
								              .value.trim(),
							operator:     this.getViewUser,
							type:         this.type,
						},
						a => {
							if (a.code === 200) {
								performRequest(
									{
										section: "tvcontent.playlist",
										name:    "getPlaylistList",
									},
									{
										operator: this.getViewUser
									},
									b => {
										this.setPlaylists(b.data);
										this.$router.push("/playlist");
									}
								);
							} else {
								this.badRequest = true;
								this.code       = a.code;
							}

						}
					);
					// this.addNewPlaylist({
					// 	name           : document.querySelector("#name").value,
					// 	display_name   : document.querySelector("#display_name").value,
					// 	balancer_domain: document.querySelector("#domain").value,
					// type           : document.querySelectorAll("#type option")[
					// 	document.querySelector("#type").selectedIndex
					// 	].innerText
					// });

				} else {
					this.error = true;
				}
			},
		},
		computed: {
			...mapGetters([
				"getPlaylists",
				"getEditingPlaylist",
				"getCountPlaylists",
				"getViewUser",
				"getReqUserRole"
			]),
		},
	};
</script>
<style scoped lang="scss">
	.new_playlist {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
		padding: 0.5rem 0.5rem 1rem 0.5rem;
		height: calc(100vh - 5rem);
		overflow: auto;
		position: absolute;
		margin-top: 4rem;
		width: 90%;
		right: 50%;
		transform: translateX(50%);
		flex-direction: column;
		
		button {
			background: #bbf291;
			border-radius: 0.2rem;
			line-height: 1.8rem;
			border: none;
			outline: none;
			height: 2.5rem;
			padding: 0.2rem 1rem;
			transition: all 0.2s;
			cursor: pointer;
			margin: 0.5rem;
			
			&:hover {
				background: #78956b;
				color: white;
				
				&:active {
					box-shadow: 0 0 1rem #967068;
				}
			}
		}
		
		.container {
			clear: both;
			margin: 0.5rem 0 0 50%;
			width: 90%;
			transform: translateX(-50%);
			
			.wrap_options {
				width: 100%;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				margin: 0.5rem;
				
				input[type='text'], select {
					max-width: 40rem;
					min-width: 20rem;
					border-radius: 3px;
					outline: none;
					border: 1px solid #c9c9c9;
					padding-left: 5px;
					flex-grow: 1;
					
					&:focus {
						box-shadow: 0 0 5px #69bf8f;
					}
				}
				
				label {
					width: 15rem;
				}
			}
		}
		div.error {
			display: inline-block;
			p#error, p#coincidence, p#bad_request {
				font-size: 1.1rem;
				color: red;
				float: none;
			}
		}
		
		p {
			float: right;
			margin: 0.5rem;
			
			.bold {
				font-weight: bold;
			}
		}
	}
	@media (max-width: 620px) {
		.new_playlist {
			min-height: calc(100vh - 9rem);
			height: auto;
			min-width: 30rem;
			margin-top: 8rem;
		}
	}
	.new_playlist-enter-active {
		transition: all 0.5s ease;
	}
	.new_playlist-leave-active {
		transition: all 0.5s ease;
	}
	.new_playlist-enter, .new_playlist-leave-to {
		opacity: 0;
	}
	.error-enter-active {
		transition: all 0.5s ease;
	}
	.error-leave-active {
		transition: all 0.5s ease;
	}
	.error-enter, .error-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/AddNewPlaylist.vue